import React, { ButtonHTMLAttributes } from 'react';
import { FaAngleRight } from 'react-icons/fa';

import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const NextButton: React.FC<ButtonProps> = ({
  id,
  disabled,
  onClick,
  ...rest
}) => {
  return (
    <Container
      id={id}
      disabled={disabled}
      isDisabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <FaAngleRight size={16} />
    </Container>
  );
};

export default NextButton;
